
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductCategoryDialog extends Serenity.EntityDialog<ProductCategoryRow, any> {
        protected getFormKey() { return ProductCategoryForm.formKey; }
        protected getIdProperty() { return ProductCategoryRow.idProperty; }
        protected getLocalTextPrefix() { return ProductCategoryRow.localTextPrefix; }
        protected getService() { return ProductCategoryService.baseUrl; }
        protected getDeletePermission() { return ProductCategoryRow.deletePermission; }
        protected getInsertPermission() { return ProductCategoryRow.insertPermission; }
        protected getUpdatePermission() { return ProductCategoryRow.updatePermission; }

        protected form = new ProductCategoryForm(this.idPrefix);

    }
}